import {POST} from "@/services/gateway";

export const listBackups = ({pagination, userIds, filter}) => {
  return POST('backup/list', {pagination, userIds, filter})
}
